export function formatTransferNumber(value) {
  if (value === null || typeof value === "undefined" || String(value).trim() === "") {
    return "";
  }

  return String(value).padStart(5, "0");
}
